export default __webpack_public_path__ + "media/bundles/App/Company/company-enterprise-105637c93c4fe2016a5d077d5f743d8e.svg";